import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { VerticalMenuModule } from './@theme/layouts/menu/vertical-menu';
import { FooterComponent } from "./@theme/layouts/footer/footer.component";
import { BreadcrumbComponent } from "./@theme/layouts/breadcrumb/breadcrumb.component";
import { NavBarModule } from "./@theme/layouts/toolbar/toolbar.module";
import { menus } from './shared/data/menu';
import { MatSidenavModule } from '@angular/material/sidenav';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { initializeKeycloak } from './configurazioni/keycloak.config';
import { KeycloakAngularModule, KeycloakService } from 'keycloak-angular';
import { ReactiveFormsModule } from '@angular/forms';
import { CreaNuovoPazienteComponent } from './components/pazienti/crea-nuovo-paziente/crea-nuovo-paziente.component';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import {  TokenInterceptor } from './configurazioni/interceptor/token.interceptor';
import { UserKeycloak } from './shared/model/user.keycloak';
import { ruoli } from './shared/data/ruoli';
import { NgxSpinnerModule } from "ngx-spinner";
import { SpinnerComponent } from "./@theme/components/spinner/spinner.component";
import { SpinnerInterceptor } from './configurazioni/interceptor/spinner.interceptor';
import {NgxPrintModule} from 'ngx-print';
import { provideCharts, withDefaultRegisterables } from 'ng2-charts';

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    VerticalMenuModule,
    FooterComponent,
    BreadcrumbComponent,
    NavBarModule,
    MatSidenavModule,
    BrowserAnimationsModule,
    FontAwesomeModule,
    KeycloakAngularModule,
    ReactiveFormsModule,
    NgxSpinnerModule,
    SpinnerComponent,
    NgxSpinnerModule.forRoot({ type: 'ball-scale-multiple' }),
    NgxPrintModule
],
  providers: [
    provideCharts(withDefaultRegisterables()),
{
    provide: APP_INITIALIZER,
    useFactory: initializeKeycloak,
    deps: [KeycloakService],
    multi: true
  },{
    provide:HTTP_INTERCEPTORS,
    useClass:TokenInterceptor,
    multi:true,
  }, {
    provide: HTTP_INTERCEPTORS,
    useClass: SpinnerInterceptor,
    multi: true,
    
  },
],
  bootstrap: [AppComponent]
})
export class AppModule {
  menus=menus
  
  
 }
